/**
 * Member Status DTO enum - wire format for member status
 * Maps to backend API status values
 */
export enum MemberStatusDTO {
  ACTIVE = 'ACTIVE',
  INVITED = 'INVITED',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  BASIC = 'BASIC',
  ARCHIVED = 'ARCHIVED',
  PLACEHOLDER = 'PLACEHOLDER',
}

/**
 * Type alias for request - makes intent clear
 */
export type MemberStatusRequest = MemberStatusDTO;

/**
 * Type alias for response - makes intent clear
 */
export type MemberStatusResponse = MemberStatusDTO;
